// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nQHk","question":"styles_question__2TEpc","description":"styles_description__2wsTd"};